import axios from "axios";
import { baseRequest } from "../utils";
import { getPage, redirectToPage } from "../utils/helpers";
import download from 'downloadjs';
import { BILL_STATUS } from "../constants/constants";
import { showNotificationMessage } from "../components";

const types = {
    FETCH_HOINVOICES_REQUEST: 'FETCH_HOINVOICES_REQUEST',
    FETCH_HOINVOICES_SUCCESS: 'FETCH_HOINVOICES_SUCCESS',
    FETCH_HOINVOICES_ERROR: 'FETCH_HOINVOICES_ERROR',

    SET_CURRENT_PAGE_HOINVOICES: 'SET_CURRENT_PAGE_HOINVOICES',

    DOWNLOAD_HOINVOICE_REQUEST: 'DOWNLOAD_HOINVOICE_REQUEST',
    DOWNLOAD_HOINVOICE_PDF_SUCCESS: 'DOWNLOAD_HOINVOICE_PDF_SUCCESS',
    DOWNLOAD_HOINVOICE_PDF_ERROR: 'DOWNLOAD_HOINVOICE_PDF_ERROR',

    DOWNLOAD_HOINVOICE_RECEIPTS_REQUEST: 'DOWNLOAD_HOINVOICE_RECEIPTS_REQUEST',
    DOWNLOAD_HOINVOICE_RECEIPTS_SUCCESS: 'DOWNLOAD_HOINVOICE_RECEIPTS_SUCCESS',
    DOWNLOAD_HOINVOICE_RECEIPTS_ERROR: 'DOWNLOAD_HOINVOICE_RECEIPTS_ERROR',
};

const fetchHOInvoicesRequest = () => ({
    type: types.FETCH_HOINVOICES_REQUEST,
});

export const setCurrentPage = (page) => ({
    type: types.SET_CURRENT_PAGE_HOINVOICES,
    payload: page,
});

const downloadHOInvoicePDFRequest = () => ({
    type: types.DOWNLOAD_HOINVOICE_REQUEST,
});

const downloadHOInvoiceReceiptsRequest = () => ({
    type: types.DOWNLOAD_HOINVOICE_RECEIPTS_REQUEST,
});

export const fetchHOInvoices = ({ value, filtered, Navigation }) => {
    const { location } = Navigation;

    const success = (response) => ({
        type: types.FETCH_HOINVOICES_SUCCESS,
        payload: response,
    });

    const failure = (error) => ({
        type: types.FETCH_HOINVOICES_ERROR,
        payload: error,
    });

    return (dispatch, getStore) => {
        if (filtered) redirectToPage(location.pathname, 1, Navigation);
        const { limit } = getStore().hoBilling;
        const currentPage = getPage(location);
        dispatch(setCurrentPage(currentPage));
        dispatch(fetchHOInvoicesRequest());
        return baseRequest(
            'GET',
            `/ho-invoice`,
            null,
            {},
            {
                docsPerPage: limit,
                page: currentPage,
                value: value || '',
            },
        )
            .then((response) => dispatch(success(response.data)))
            .catch((error) => {
                if (error) dispatch(failure([]));
            });
    };
};

export const downloadHOInvoicePDF = (payload) => {
    const success = (payload) => ({
        type: types.DOWNLOAD_HOINVOICE_PDF_SUCCESS,
        payload,
    });

    const failure = (error) => ({
        type: types.DOWNLOAD_HOINVOICE_PDF_ERROR,
        payload: error,
    });

    return (dispatch) => {
        dispatch(downloadHOInvoicePDFRequest());
        return baseRequest('GET', `/auth/signed`, null, null, {
            fPath: payload,
        }).then(async (response) => {
            await axios({ url: response.data, method: 'GET', responseType: 'blob' })
                .then((response) => {
                    dispatch(success(response));
                    download(new Blob([response.data]), `invoice.pdf`, response.headers['content-type']);
                    showNotificationMessage({ type: 'success', content: 'Invoice downloaded successfully' });
                })
                .catch(() => {
                    dispatch(failure(''));
                    showNotificationMessage({ type: 'error', content: 'Failed to download invoice' });
                });
        }).catch(() => {
            dispatch(failure(''));
            showNotificationMessage({ type: 'error', content: 'Failed to download invoice' });
        });
    };
};

export const downloadHOInvoiceReceipts = ({ invoiceId, fileType, isEnterpriseAdmin }) => {
    const success = (payload) => ({
        type: types.DOWNLOAD_HOINVOICE_RECEIPTS_SUCCESS,
        payload,
    });

    const failure = (error) => ({
        type: types.DOWNLOAD_HOINVOICE_RECEIPTS_ERROR,
        payload: error,
    });

    return (dispatch) => {
        dispatch(downloadHOInvoiceReceiptsRequest());
        return baseRequest(
            'POST',
            `/ride-requests/report`,
            { fileType: fileType || 'xlsx', filters: { hoInvoiceId: invoiceId, billed: BILL_STATUS.value, isEnterpriseAdmin } },
            [],
            [],
            'blob',
        )
            .then((response) => {
                const extension = response.headers['content-type'] === 'text/csv' ? 'csv' : 'xlsx';
                download(response.data, `export.${extension}`, response.headers['content-type']);
                dispatch(success(response));
                showNotificationMessage({ type: 'success', content: 'Report exported successfully' });
            })
            .catch(() => {
                dispatch(failure(''));
                showNotificationMessage({ type: 'error', content: 'Failed to export report' });
            });
    };
};

const initialState = {
    hoInvoices: [],
    loading: false,
    error: false,
    success: false,
    limit: 10,
    currentPage: 1,
    totalPages: 1,
    total: 1,
};

export default function hoBilling(state = initialState, action) {
    switch (action.type) {
        case types.FETCH_HOINVOICES_REQUEST:
            return { ...state, loading: true };
        case types.FETCH_HOINVOICES_SUCCESS:
            return {
                ...state,
                hoInvoices: action.payload.data,
                totalPages: action.payload.meta.totalPages,
                total: action.payload.meta.total,
                limit: action.payload.meta.limit,
                currentPage: action.payload.meta.currentPage,
                loading: false,
            };
        case types.FETCH_HOINVOICES_ERROR:
            return { ...state, loading: false };
        case types.DOWNLOAD_HOINVOICE_REQUEST:
            return { ...state, loading: true };
        case types.DOWNLOAD_HOINVOICE_PDF_SUCCESS:
            return { ...state, loading: false };
        case types.DOWNLOAD_HOINVOICE_PDF_ERROR:
            return { ...state, loading: false };
        case types.DOWNLOAD_HOINVOICE_RECEIPTS_REQUEST:
            return { ...state, loading: true };
        case types.DOWNLOAD_HOINVOICE_RECEIPTS_SUCCESS:
            return { ...state, loading: false };
        case types.DOWNLOAD_HOINVOICE_RECEIPTS_ERROR:
            return { ...state, loading: false };
        default:
            return state;
    }
}
